import { combineReducers } from 'redux';
import type { RootState } from '../@types';
import searchReducer from './searchReducer';

/**
 * Combine reducers here
 */
export default combineReducers<RootState>({
	search: searchReducer,
});
